export const API_WEBHOOK_CONTENT_ENROLLMENT_PATH_KEY = '/webhook/content-enrollment';
export const API_SYNC_CATALOG_PATH_KEY = '/sync-catalog';
export const API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_GETALL_PATH_KEY =
  '/organizations/{organizationId}/contents/getAll';
export const API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_RECENTS_PATH_KEY =
  '/organizations/{organizationId}/contents/recents';
export const API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_DASHBOARD_PATH_KEY =
  '/organizations/{organizationId}/contents/dashboard';
export const API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_PATH_KEY =
  '/organizations/{organizationId}/contents';
export const API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_ME_PATH_KEY =
  '/organizations/{organizationId}/contents/me';
export const API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_CONTENTID_DETAILS_PATH_KEY =
  '/organizations/{organizationId}/contents/{contentId}/details';
export const API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_CONTENTID_START_PATH_KEY =
  '/organizations/{organizationId}/contents/{contentId}/start';
export const API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_CONTENTID_PROGRESS_PATH_KEY =
  '/organizations/{organizationId}/contents/{contentId}/progress';
export const API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_CONTENTID_END_PATH_KEY =
  '/organizations/{organizationId}/contents/{contentId}/end';
export const API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_TAGS_PATH_KEY =
  '/organizations/{organizationId}/contents/tags';
export const API_ORGANIZATIONS_ORGANIZATIONID_USER_CONTENT_FAVORITES_PATH_KEY =
  '/organizations/{organizationId}/user/content-favorites';
export const API_ORGANIZATIONS_ORGANIZATIONID_USER_CONTENT_FAVORITES_CONTENTID_PATH_KEY =
  '/organizations/{organizationId}/user/content-favorites/{contentId}';
